<admin-app-header></admin-app-header>

<div class="aff-page">
    <div class="container-fluid">
        <div class="loading" *ngIf="loading && !detail"><i class="fa-solid fa-spinner fa-spin"></i> Loading...</div>

        <ng-container *ngIf="detail as d">
            <div class="page-header">
                <div>
                    <a [routerLink]="['/admin/affiliates']" class="muted"><i class="fa-solid fa-arrow-left"></i> Affiliates</a>
                    <h1>
                        {{ d.affiliate.displayName }} <span class="badge" [ngClass]="'badge--' + d.affiliate.status">{{ d.affiliate.status | titlecase }}</span>
                        <span class="badge" [ngClass]="isGuard ? 'badge--guard' : $any(d.affiliate).kind === Kind.LANDLORD_PROMOTER ? 'badge--landlord' : 'badge--parker'">{{
                            kindLabel($any(d.affiliate).kind)
                        }}</span>
                    </h1>
                    <p class="subtitle">
                        Code <strong>{{ d.affiliate.code }}</strong> ·
                        <ng-container *ngIf="!isGuard">{{ $any(d.affiliate).email }}</ng-container>
                        <ng-container *ngIf="isGuard">{{ $any(d.affiliate).phone || 'No phone' }} · no ParkUpp login</ng-container>
                        · affiliate since {{ d.affiliate.createdAt | date: 'd MMM y' }}
                    </p>
                </div>
                <div class="page-header__actions" *ngIf="!isGuard">
                    <a class="btn btn-secondary" [routerLink]="['/client', uid]"><i class="fa-solid fa-user"></i> Client profile</a>
                    <a class="btn btn-secondary" [routerLink]="['/client', uid, 'affiliate']"><i class="fa-solid fa-eye"></i> Their affiliate page</a>
                </div>
            </div>

            <div class="stats-grid">
                <div class="stat">
                    <span class="stat__value">{{ d.affiliate.stats.uniqueClicks | number }}</span>
                    <span class="stat__label">Link visits ({{ d.affiliate.stats.clicks | number }} loads)</span>
                </div>
                <div class="stat">
                    <span class="stat__value">{{ d.affiliate.stats.signups | number }}</span>
                    <span class="stat__label">Sign-ups via link</span>
                </div>
                <div class="stat">
                    <span class="stat__value">{{ d.affiliate.stats.parkerReferrals | number }} / {{ d.affiliate.stats.landlordReferrals | number }} / {{ d.affiliate.stats.buildingReferrals || 0 | number }}</span>
                    <span class="stat__label">Parkers / landlords / buildings</span>
                </div>
                <div class="stat stat--orange">
                    <span class="stat__value">R {{ d.balances.pending + d.balances.approved | number: '1.2-2' }}</span>
                    <span class="stat__label">Next statement</span>
                </div>
                <div class="stat stat--green">
                    <span class="stat__value">R {{ d.balances.requested | number: '1.2-2' }}</span>
                    <span class="stat__label">On statements, unpaid</span>
                </div>
                <div class="stat">
                    <span class="stat__value">R {{ d.balances.paid | number: '1.2-2' }}</span>
                    <span class="stat__label">Paid</span>
                </div>
            </div>

            <div class="card">
                <div class="card__head">
                    <h2>Link visits, last 90 days</h2>
                    <span class="muted">{{ clicks90 | number }} unique visitor-days</span>
                </div>
                <div class="bar-chart">
                    <div class="bar" *ngFor="let c of clickDays" [style.height.%]="(c.clicks / maxClicks) * 100" [title]="c.day + ': ' + c.clicks"></div>
                </div>
            </div>

            <div class="card">
                <div class="card__head"><h2>Settings</h2></div>
                <div class="form-grid">
                    <label class="field"
                        >Status
                        <select [(ngModel)]="settings.status">
                            <option *ngFor="let s of statuses" [value]="s">{{ s | titlecase }}</option>
                        </select>
                    </label>
                    <ng-container *ngIf="!isGuard">
                        <label class="field"
                            >Type
                            <select [(ngModel)]="settings.kind">
                                <option *ngFor="let k of promoterKinds" [value]="k">{{ kindLabel(k) }}</option>
                            </select>
                        </label>
                        <label class="field">Parker fee share (% of Trading Income)<input type="number" min="0" max="100" [(ngModel)]="settings.parkerCommissionPct" /></label>
                        <label class="field">Building fee share (% of Trading Income)<input type="number" min="0" max="100" [(ngModel)]="settings.landlordCommissionPct" /></label>
                        <label class="field">Parker period (months from first booking)<input type="number" min="1" max="120" [(ngModel)]="settings.parkerWindowMonths" /></label>
                        <label class="field">Building period (months from first listing)<input type="number" min="1" max="120" [(ngModel)]="settings.landlordWindowMonths" /></label>
                    </ng-container>
                    <ng-container *ngIf="isGuard">
                        <label class="field">Name<input [(ngModel)]="settings.displayName" maxlength="120" /></label>
                        <label class="field">Cellphone<input [(ngModel)]="settings.phone" maxlength="30" inputmode="tel" /></label>
                        <label class="field">Email (optional)<input type="email" [(ngModel)]="settings.guardEmail" maxlength="200" /></label>
                        <label class="field">Bounty per parker (R)<input type="number" min="0" [(ngModel)]="settings.bountyAmount" /></label>
                        <label class="field">Paid after this many paid invoices<input type="number" min="1" max="36" [(ngModel)]="settings.bountyPaidInvoices" /></label>
                    </ng-container>
                    <label class="field" style="grid-column: 1 / -1">Notes<textarea rows="2" [(ngModel)]="settings.notes"></textarea></label>
                </div>
                <p class="muted" *ngIf="isGuard">
                    Security guard: no login and no fee share. They earn R{{ settings.bountyAmount }} once for each parker they bring, when that parker has paid
                    {{ settings.bountyPaidInvoices }} invoices. Changes apply to bounties that become due from now on.
                </p>
                <p class="muted" *ngIf="!isGuard">
                    Paused: no new clicks or sign-ups are credited for now. Terminated: the agreement has ended, so no new introductions count, but introductions already made keep
                    earning for the rest of their 12 months and keep appearing on statements (Fee Share Agreement §5). Rate changes apply to payments from now on; periods apply to new
                    introductions.
                </p>
                <div class="modal-aff__actions">
                    <button class="btn btn-primary" (click)="saveSettings()" [disabled]="saving">Save settings</button>
                </div>
            </div>

            <div class="card" *ngIf="isGuard">
                <div class="card__head">
                    <h2>Bounties</h2>
                    <div class="page-header__actions">
                        <span class="muted">Due R {{ bountyTotal(BountyStatus.DUE) | number: '1.2-2' }} · Paid R {{ bountyTotal(BountyStatus.PAID) | number: '1.2-2' }}</span>
                        <a class="btn btn-secondary btn-sm" [routerLink]="['/admin/affiliate-payouts']" [queryParams]="{ tab: 'bounties' }">Pay bounties</a>
                    </div>
                </div>
                <div class="empty" *ngIf="!d.bounties?.length">
                    None yet. A bounty appears here when one of their parkers has paid {{ settings.bountyPaidInvoices }} invoices.
                </div>
                <div class="table-wrap" *ngIf="d.bounties?.length">
                    <table class="aff-table">
                        <thead>
                            <tr>
                                <th>Parker</th>
                                <th>Due since</th>
                                <th class="num">Amount</th>
                                <th>Status</th>
                                <th>Paid</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let b of d.bounties">
                                <td>
                                    <a [routerLink]="['/client', b.clientKey]">{{ b.denormClientName || b.clientKey }}</a>
                                    <span class="sub">{{ b.paidInvoicesAtQualifying }} paid invoices</span>
                                </td>
                                <td>{{ b.qualifiedAt | date: 'd MMM y' }}</td>
                                <td class="num">R {{ b.amount | number: '1.2-2' }}</td>
                                <td><span class="badge" [ngClass]="'badge--' + b.status">{{ b.status | titlecase }}</span></td>
                                <td>
                                    <span *ngIf="b.paidAt">{{ b.paidAt | date: 'd MMM y' }} · {{ b.paymentMethod | titlecase }}</span>
                                    <span class="sub" *ngIf="b.reference">{{ b.reference }}</span>
                                    <span class="sub" *ngIf="b.notes">{{ b.notes }}</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card">
                <div class="card__head"><h2>Links</h2></div>
                <table class="aff-table">
                    <tr>
                        <td>Parkers</td>
                        <td>
                            <code>{{ links.parker }}</code>
                        </td>
                        <td class="num">
                            <button class="btn btn-secondary btn-sm" (click)="copy(links.parker)">Copy</button>
                            <button class="btn btn-secondary btn-sm" (click)="shareLink = 'parker'"><i class="fa-solid fa-share-nodes"></i> Sharing options</button>
                        </td>
                    </tr>
                    <tr>
                        <td>Landlords</td>
                        <td>
                            <code>{{ links.landlord }}</code>
                        </td>
                        <td class="num">
                            <button class="btn btn-secondary btn-sm" (click)="copy(links.landlord)">Copy</button>
                            <button class="btn btn-secondary btn-sm" (click)="shareLink = 'landlord'"><i class="fa-solid fa-share-nodes"></i> Sharing options</button>
                        </td>
                    </tr>
                    <tr *ngIf="!isGuard">
                        <td>Bank</td>
                        <td colspan="2">
                            <span *ngIf="d.payoutDetails">{{ d.payoutDetails.bank }} · {{ d.payoutDetails.accountHolder }} · {{ d.payoutDetails.accountNumber }} · branch {{ d.payoutDetails.branchCode || '—' }}</span>
                            <span *ngIf="!d.payoutDetails" class="muted">Not provided yet</span>
                        </td>
                    </tr>
                </table>
            </div>

            <div class="card">
                <div class="card__head">
                    <h2>Referrals</h2>
                    <div class="page-header__actions">
                        <a class="btn btn-secondary btn-sm" *ngIf="!isGuard" [routerLink]="['/admin/affiliates']" [queryParams]="{ tab: 'landlords' }">Credit a landlord or building</a>
                        <button class="btn btn-secondary btn-sm" (click)="showAttach = !showAttach">Add a parker</button>
                    </div>
                </div>
                <div class="notice" *ngIf="showAttach">
                    <div class="filters">
                        <label class="field" style="flex: 1">Parker's email<input [(ngModel)]="attachEmail" (keyup.enter)="findParker()" /></label>
                        <button class="btn btn-secondary" (click)="findParker()">Find</button>
                    </div>
                    <div *ngIf="attachFound" style="margin-top: 12px">
                        <strong>{{ attachFound.name }}</strong>
                        <label class="field" style="margin-top: 8px">Notes (why)<input [(ngModel)]="attachNotes" /></label>
                        <label class="check"><input type="checkbox" [(ngModel)]="attachReplace" /> Replace an existing referral for this parker</label>
                        <button class="btn btn-primary btn-sm" (click)="attachParker()" [disabled]="saving">Add referral</button>
                    </div>
                </div>
                <div class="empty" *ngIf="!d.referrals.length">No referrals yet.</div>
                <div class="table-wrap" *ngIf="d.referrals.length">
                    <table class="aff-table">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Type</th>
                                <th>How</th>
                                <th>Fee share period</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let r of d.referrals">
                                <td>
                                    <a *ngIf="r.type === ReferralType.PARKER && r.referredUid" [routerLink]="['/client', r.referredUid]">{{ r.name }}</a>
                                    <a *ngIf="r.type !== ReferralType.PARKER && r.merchantKey" [routerLink]="['/merchant', r.merchantKey]">{{ r.name }}</a>
                                    <span class="sub" *ngIf="r.notes">{{ r.notes }}</span>
                                </td>
                                <td>
                                    <span class="badge" [ngClass]="'badge--' + (r.type === ReferralType.PARKER ? 'parker' : 'landlord')">{{ r.type | titlecase }}</span>
                                </td>
                                <td>{{ r.source === 'admin' ? 'Added by admin' : 'Via link' }}</td>
                                <td>
                                    <ng-container *ngIf="r.startsAt">{{ r.startsAt | date: 'd MMM y' }} – {{ r.endsAt | date: 'd MMM y' }}</ng-container>
                                    <span *ngIf="!r.startsAt && r.type === ReferralType.PARKER" class="sub">Starts at first booking</span>
                                    <span *ngIf="!r.startsAt && r.type === ReferralType.BUILDING" class="sub">Starts at first listing</span>
                                    <span *ngIf="r.type === ReferralType.LANDLORD" class="sub">Doesn't earn; credits new buildings</span>
                                </td>
                                <td><span class="badge" [ngClass]="'badge--' + r.status">{{ r.status | titlecase }}</span></td>
                                <td class="num"><button class="btn btn-danger btn-sm" *ngIf="r.status === 'active'" (click)="revoke(r)">Remove</button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card">
                <div class="card__head">
                    <h2>Ledger</h2>
                    <span class="muted">Every paid invoice this affiliate had a claim on, including ones where another referral took priority.</span>
                </div>
                <div class="empty" *ngIf="!d.commissionsRaw.length">No paid invoices yet.</div>
                <div class="table-wrap" *ngIf="d.commissionsRaw.length">
                    <table class="aff-table">
                        <thead>
                            <tr>
                                <th>Paid</th>
                                <th>Invoice</th>
                                <th>Building / parker</th>
                                <th class="num">Invoice</th>
                                <th class="num" title="ParkUpp fee on the rental excl. VAT, less banking fee">Trading Income</th>
                                <th>Claim</th>
                                <th class="num">Fee share</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let c of d.commissionsRaw">
                                <td>{{ c.paymentDate | date: 'd MMM y' }}</td>
                                <td>
                                    <a *ngIf="c.clientKey" [routerLink]="['/client', c.clientKey, 'invoice', c.invoiceKey]">#{{ c.invoiceNumber || c.invoiceKey.slice(0, 6) }}</a>
                                </td>
                                <td>
                                    {{ c.denormParkingTitle }}<span class="sub">{{ c.denormClientName }}</span>
                                </td>
                                <td class="num">R {{ c.grossAmount | number: '1.2-2' }}</td>
                                <td class="num">
                                    R {{ c.basisAmount | number: '1.2-2' }}
                                    <span class="sub" *ngIf="c.rentalExclVat !== undefined"
                                        >{{ c.platformCommissionPct }}% of R{{ c.rentalExclVat | number: '1.2-2' }} − R{{ c.bankingFee | number: '1.2-2' }} bank</span
                                    >
                                </td>
                                <td>
                                    <span class="badge" [ngClass]="'badge--' + (mine(c).type === ReferralType.PARKER ? 'parker' : 'landlord')">{{ mine(c).type | titlecase }}</span>
                                    <span class="sub" *ngIf="mine(c).outcome !== Outcome.EARNED">{{ outcomeLabel(mine(c).outcome) }}</span>
                                    <span class="sub" *ngFor="let o of others(c)">Also claimed: {{ o.type }} ({{ outcomeLabel(o.outcome) }})</span>
                                </td>
                                <td class="num" [class.strike]="mine(c).outcome !== Outcome.EARNED">R {{ mine(c).amount | number: '1.2-2' }}</td>
                                <td>
                                    <span class="badge" [ngClass]="'badge--' + (mine(c).outcome === Outcome.EARNED ? c.status : 'suppressed')">{{
                                        mine(c).outcome === Outcome.EARNED ? (c.status | titlecase) : 'Not earned'
                                    }}</span>
                                    <span class="sub" *ngIf="c.clawbackPending">Refunded after payout</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="card" *ngIf="d.payoutRequests.length">
                <div class="card__head">
                    <h2>Monthly statements</h2>
                    <a class="btn btn-secondary btn-sm" [routerLink]="['/admin/affiliate-payouts']">Manage statements</a>
                </div>
                <table class="aff-table">
                    <thead>
                        <tr>
                            <th>Month</th>
                            <th class="num">Amount</th>
                            <th>Pay by</th>
                            <th>Status</th>
                            <th>Reference</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of d.payoutRequests">
                            <td>{{ r.period ? (r.period + '-01' | date: 'MMMM y') : (r.requestedAt | date: 'd MMM y') }}</td>
                            <td class="num">R {{ r.amount | number: '1.2-2' }}</td>
                            <td>{{ r.dueDate ? (r.dueDate | date: 'd MMM y') : '—' }}</td>
                            <td><span class="badge" [ngClass]="'badge--' + r.status">{{ r.status === 'requested' ? 'Due' : (r.status | titlecase) }}</span></td>
                            <td>{{ r.reference || '—' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <app-share-link-modal
                *ngIf="shareLink"
                [url]="links[shareLink]"
                [title]="shareLink === 'parker' ? 'Parker link: ' + d.affiliate.code : 'Landlord link: ' + d.affiliate.code"
                [shareText]="shareLink === 'parker' ? 'Find monthly parking on ParkUpp:' : 'List your parking bays on ParkUpp and earn from empty bays:'"
                [emailSubject]="shareLink === 'parker' ? 'Monthly parking on ParkUpp' : 'Earn from your empty parking bays with ParkUpp'"
                [fileName]="'parkupp-' + shareLink + '-' + d.affiliate.code"
                (closed)="shareLink = null"
            ></app-share-link-modal>
        </ng-container>
    </div>
</div>
